import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["slide"]

  connect() {
    this.index = 0
    this.touchStartX = null
    this.swiped = false
    this.show(0)
  }

  previous(event) {
    this.stopNavigation(event)
    this.show(this.index - 1)
  }

  next(event) {
    this.stopNavigation(event)
    this.show(this.index + 1)
  }

  touchStart(event) {
    this.touchStartX = event.changedTouches[0]?.clientX
  }

  touchEnd(event) {
    if (this.touchStartX == null) return

    const distance = event.changedTouches[0]?.clientX - this.touchStartX
    this.touchStartX = null
    if (Math.abs(distance) < 40) return

    event.preventDefault()
    event.stopPropagation()
    this.swiped = true
    this.show(distance > 0 ? this.index - 1 : this.index + 1)
    window.setTimeout(() => { this.swiped = false }, 400)
  }

  preventNavigation(event) {
    if (!this.swiped) return

    event.preventDefault()
    event.stopPropagation()
  }

  show(nextIndex) {
    const count = this.slideTargets.length
    if (count < 2) return

    this.index = (nextIndex + count) % count
    this.slideTargets.forEach((slide, index) => {
      if (index === this.index && slide.dataset.src) {
        slide.src = slide.dataset.src
        delete slide.dataset.src
      }
      slide.classList.toggle("is-active", index === this.index)
    })
  }

  stopNavigation(event) {
    event.preventDefault()
    event.stopPropagation()
  }
}
